import { render, staticRenderFns } from "./Okazaki.vue?vue&type=template&id=5ffef89d&scoped=true&"
import script from "./Okazaki.vue?vue&type=script&lang=js&"
export * from "./Okazaki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffef89d",
  null
  
)

export default component.exports